import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { useResponsiveView } from './useResponsiveView.js';
import { FormContainer } from './FormContainer2.js';
import { FormField } from './DynamicForm3.js';

function DynamicForm({ fieldsStructure, columnsCount = 1, form, columnsCountForMobile = 1, }) {
    const { max_sm } = useResponsiveView();
    const columns = max_sm ? columnsCountForMobile : columnsCount;
    return (jsx(FormContainer, { columnsCount: columns, children: fieldsStructure.map((fieldSchema, i) => {
            if (!fieldSchema || fieldSchema.isHidden)
                return jsx(React__default.Fragment, {}, i);
            const field = fieldSchema.field;
            return (jsx(FormField, { form: form, field: field, schema: fieldSchema, columnsCount: columns }, `${field}-${i}`));
        }) }));
}

export { DynamicForm as default };
